import { isExpiredIndicatorMenuItem } from '@/common/store/expiredIndicator/menuItem';
import { EXPIRED_INDICATOR_GETTERS_NAME } from '@/common/store/expiredIndicator/name';

export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  computed: {
    hasWarning() {
      const hasExpired = this.$store.getters[EXPIRED_INDICATOR_GETTERS_NAME.hasExpiredIndicator];
      if (!this.item) return hasExpired;
      return hasExpired && isExpiredIndicatorMenuItem(this.item);
    },
  },
};
